module.exports = __webpack_public_path__ + "static/media/bg-mobile2.14bf3918.png";